import { mapUpdateCageRequestToApi, mapUpdateCageResponseToDomain } from '@/domain/cages/mappers';
import type {
    UpdateCageResult,
    UpdateCageVariables,
    UseUpdateCageResult,
} from '@/domain/cages/types';
import type { DomainMutationOptions } from '@/domain/shared/types';
import { useCageController_updateCage } from '@/services/hooks';
import type { UpdateCageDto, UpdateCageResponse } from '@/services/types';

type UseUpdateCageOptions = DomainMutationOptions<
    {
        cageId: number;
        requestBody: UpdateCageDto;
    },
    UpdateCageResponse
>;

export const useUpdateCage = (options?: UseUpdateCageOptions): UseUpdateCageResult => {
    const mutation = useCageController_updateCage(options);

    const mutateAsync = async (variables: UpdateCageVariables): Promise<UpdateCageResult> => {
        const { cageId, requestBody } = variables;

        // Mapping Domain to API
        const requestBodyToSend: UpdateCageDto = mapUpdateCageRequestToApi(requestBody);

        const result = await mutation.mutateAsync({ cageId, requestBody: requestBodyToSend });
        return mapUpdateCageResponseToDomain(result.data);
    };

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: mutation.data ? mapUpdateCageResponseToDomain(mutation.data.data) : undefined,
    };
};
